/**
 * The code `callEdgeFunction` returns when the CLIENT gave up waiting.
 *
 * A leaf module on purpose: it is shared between the producer
 * (`edge-functions.ts`) and the consumers that must treat it specially
 * (`pitch-deck-analysis.ts`, the analysis modal), and neither should have to
 * import the other's dependency graph to agree on one string.
 *
 * WHY THE DISTINCTION MATTERS
 * ---------------------------
 * The timeout is a client-side `AbortController`. Aborting the fetch stops the
 * client listening; it does NOT stop the edge function, which runs to
 * completion and COMMITS its work. "Timed out" and "failed" are therefore
 * different events.
 *
 * Conflating them is not cosmetic. On 2026-07-31 an investor saw "Analysis
 * Failed — Request timed out after 150s" for a deck whose analysis had fully
 * succeeded: the company was created, scored, given a deck-sourced logo and
 * privately promoted. Reporting failure invites a retry of a pipeline that
 * already worked — three more LLM passes, and a duplicate company on any
 * identity key not covered by a constraint.
 */
export const CLIENT_TIMEOUT_CODE = 'CLIENT_TIMEOUT';
